import FastMarquee from "react-fast-marquee";

const items = ["Reliable", "Trust Worthy", "Honest"];

export default function Marquee() {
  return (
    <section className="bg-bone border-y border-navy/10 overflow-hidden" data-testid="marquee-section">
      <FastMarquee speed={30} gradient={false} pauseOnHover>
        <div className="flex items-center py-10">
          {items.concat(items).concat(items).map((it, i) => (
            <span key={i} className="flex items-center gap-10 pl-10">
              <span
                className="text-6xl md:text-8xl lg:text-9xl leading-none whitespace-nowrap uppercase font-display font-black tracking-tight text-navy"
              >
                {it}
              </span>
              <span className="w-3 h-3 bg-navy inline-block" />
            </span>
          ))}
        </div>
      </FastMarquee>
    </section>
  );
}
